import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthService } from './auth.service';
import { AuthGuardService } from './auth-guard.service';
import { HasPreviousRouteService } from './previous-route.service';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    AuthGuardService,
    HasPreviousRouteService,
    AuthService
  ]
})
export class CoreModule {
}
